<template>
    <div>
        <a-form :form="form" layout="vertical"  @submit="handleSubmit">
            <b-row>
                <b-col cols="12" md="6">
                    <b-col>
                        <!-- bankSystem -->
                        <a-form-item label="บัญชีธนาคารระบบ">
                            <a-select
                            option-filter-prop="children"
                            show-search
                            :filter-option="filterOption"
    @focus="handleFocus"
    @blur="handleBlur"
    @change="handleChange"
                                size="large"
                                placeholder="กรุณาเลือกข้อมูล"
                                v-decorator="[
                                'bankServiceId',
                                    {rules: [{ required: true, message: 'กรุณาเลือกข้อมูล' }]}
                                ]"
                            >
                                <a-select-option
                                    v-for="(item , index) in bankService"
                                    :key="index"
                                    :value="item.bankServiceId"

                                >
                                    {{ item.bankServiceSystem }}
                                </a-select-option>
                            </a-select>
                        </a-form-item>
                    </b-col>
                    <b-col>
                        <!-- channel -->
                        <a-form-item label="ช่องทาง">
                            <a-input
                                size="large"
                                 v-decorator="[
                                    'channel',
                                    {rules: [{ required: true, message: 'กรุณากรอกข้อมูล' }]}
                                ]"
                            />
                        </a-form-item>
                    </b-col>
                    <b-col>
                        <!-- amount -->
                        <a-form-item label="จำนวนเงิน">
                            <a-input-number
                                size="large"
                                style="width: 100%"
                                v-decorator="[
                                    'amount',
                                    {rules: [{ required: true, message: 'กรุณากรอกข้อมูล' }]}
                                ]"
                            />
                        </a-form-item>
                    </b-col>
                </b-col>
                 <b-col cols="12" md="6">
                    <b-col>
                        <!-- datetimeTranfer -->
                        <a-form-item label="วันที่และเวลา">
                          <a-config-provider :locale="locale">
                            <a-date-picker
                                size="large"
                                show-time
                                format="DD/MM/YYYY HH:mm:ss"
                                style="width: 100%"
                                v-decorator="[
                                    'datetimeTranfer',
                                    {rules: [{ required: true, message: 'กรุณาเลือกวันที่และเวลา' }]}
                                ]"
                            >
                                <a-icon slot="suffixIcon" type="smile" />
                            </a-date-picker>
                            </a-config-provider>
                        </a-form-item>
                    </b-col>
                     <b-col>
                        <!-- detailBankNumber -->
                        <a-form-item label="บัญชีที่โอน">
                            <a-input
                                size="large"
                                v-decorator="[
                                    'detailBankNumber',
                                    {rules: [{ required: true, message: 'กรุณากรอกข้อมูล' }]}
                                ]"
                            />
                        </a-form-item>
                    </b-col>
                     <b-col>
                        <!-- detail -->
                        <a-form-item label="หมายเหตุ">
                            <a-textarea
                                size="large"
                                 v-decorator="[
                                    'detail',
                                    {rules: [{ required: true, message: 'กรุณากรอกข้อมูล' }]}
                                ]"
                                placeholder="กรุณากรอกหมายเหตุ"
                                :auto-size="{ minRows: 3, maxRows: 5 }"
                            />
                        </a-form-item>
                    </b-col>
                </b-col>
                <b-col cols="12">
                     <div class="text-center">
                        <a-button  size="large" :loading="confirmLoading" type="primary" html-type="submit">สร้างรายการ</a-button>
                    </div>
                </b-col>
            </b-row>
        </a-form>
    </div>
</template>

<script>
import thTH from 'ant-design-vue/es/locale/th_TH'
import 'moment/locale/th'
import moment from 'moment'
import apiClient from '@/services/api'
import Swal from 'sweetalert2'
moment.locale('th')
const Toast = Swal.mixin({
  toast: true,
  position: 'top-end',
  showConfirmButton: false,
  timer: 3000,
  timerProgressBar: true,
  didOpen: (toast) => {
    toast.addEventListener('mouseenter', Swal.stopTimer)
    toast.addEventListener('mouseleave', Swal.resumeTimer)
  },
})
export default {
  data() {
    return {
      locale: thTH,
      thTH,
      confirmDirty: false,
      confirmLoading: false,
      expand: false,
      form: this.$form.createForm(this, { name: 'formStatement' }),
      bankService: [],
      config: {
        bankService: [{ required: true, message: 'กรุณาเลือกข้อมูล' }],
      },

    }
  },
  // beforeCreate() {
  //     this.form = this.$form.createForm('formStatment')
  // },
  methods: {
    handleChange(value) {
      // console.log(`selected ${value}`)
    },
    handleBlur() {
      // console.log('blur')
    },
    handleFocus() {
      // console.log('focus')
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      )
    },
    async getBankSystem() {
      await apiClient.get('/system/getBankService').then(response => {
        const res = response.data
        if (res.code === '000') {
          this.bankService = res.responseData.data
        }
      }).catch(error => {
        Swal.showValidationMessage(
          `เกิดข้อผิดพลาด: ${error.message}`,
        )
      })
    },
    handleSubmit(e) {
      e.preventDefault()
      this.form.validateFieldsAndScroll((err, values) => {
        if (!err) {
          this.confirmInsert(values)
        }
      })
    },
    handleSelectChange(value) {
      // console.log(value)
      this.form.setFieldsValue({
        note: `Hi, ${value === 'male' ? 'man' : 'lady'}!`,
      })
    },
    confirmInsert(dataForm) {
      dataForm.datetimeTranfer = moment(dataForm.datetimeTranfer).format('YYYY-MM-DD HH:mm:ss')

      Swal.fire({
        icon: 'info',
        title: 'แน่ใจหรือไม่ที่ต้องการเพิ่มข้อมูล',
        showCancelButton: true,
        confirmButtonText: 'ยืนยัน',
        cancelButtonText: 'ยกเลิก',
        showLoaderOnConfirm: true,
        preConfirm: (value) => {
          if (value) {
            this.confirmLoading = true
            return apiClient.post('statement/create', dataForm).then(response => {
              if (response.status !== 200) throw new Error(response.message)
              return response.data
            }).catch(error => {
              Swal.showValidationMessage(
                `เกิดข้อผิดพลาด: ${error.message}`,
              )
            })
          }
        },
        allowOutsideClick: () => !Swal.isLoading(),
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
          const iconError = (result.value.code === '000') ? 'success' : 'error'
          Toast.fire({ icon: iconError, title: result.value.message })
          this.confirmLoading = false
          this.form.resetFields()
          this.$emit('set-start')
        }
      })
    },
    loading(e) {
      if (e) {
        Swal.fire({
          title: 'กำลังตรวจสอบ',
          html: 'ระบบกำลังตรวจสอบข้อมูล กรุณารอสักครู่.',
          showConfirmButton: false,
          allowOutsideClick: false,
          onBeforeOpen: () => {
            Swal.showLoading()
          },
        })
      } else {

      }
    },
    clearForm(e) {
      if (e === 'success') {
        this.form = {
          bankServiceId: null,
          channel: null,
          amount: null,
          datetimeTranfer: null,
          detailBankNumber: null,
          detail: null,
        }
      }
    },
  },
  async created() {
    await this.getBankSystem()
  },
}
</script>

<style>

</style>
